export default __webpack_public_path__ + "static/swipe-f93cfdcd1fba3ba00aad95fe7ef8e7f6.jpg";